import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { RequireAuth } from './components/RequireAuth'
import { DashboardPage } from './pages/DashboardPage'
import { SitesPage } from './pages/SitesPage'
import { SiteDetailPage } from './pages/SiteDetailPage'
import { RunDetailPage } from './pages/RunDetailPage'
import { FixDetailPage } from './pages/FixDetailPage'
import { BillingPage } from './pages/BillingPage'
import { OnboardPage } from './pages/OnboardPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { SignInPage } from './pages/auth/SignInPage'
import { SignUpPage } from './pages/auth/SignUpPage'
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage'
import { SettingsLayout } from './pages/settings/SettingsLayout'
import { ProfilePage } from './pages/settings/ProfilePage'
import { TeamPage } from './pages/settings/TeamPage'
import { IntegrationsPage } from './pages/settings/IntegrationsPage'
import { SecurityPage } from './pages/settings/SecurityPage'
import { DangerPage } from './pages/settings/DangerPage'
import { AdminLayout } from './pages/admin/AdminLayout'
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage'
import { AdminTenantsPage } from './pages/admin/AdminTenantsPage'
import { AdminTenantDetailPage } from './pages/admin/AdminTenantDetailPage'
import { AdminUsersPage } from './pages/admin/AdminUsersPage'
import { AdminUserDetailPage } from './pages/admin/AdminUserDetailPage'
import { AdminSitesPage } from './pages/admin/AdminSitesPage'
import { AdminRunsPage } from './pages/admin/AdminRunsPage'
import { AdminFixesPage } from './pages/admin/AdminFixesPage'
import { AdminAISpendPage } from './pages/admin/AdminAISpendPage'
import { AdminEnginesPage } from './pages/admin/AdminEnginesPage'
import { AdminRulesPage } from './pages/admin/AdminRulesPage'
import { AdminAuditLogPage } from './pages/admin/AdminAuditLogPage'
import { AdminPlatformHealthPage } from './pages/admin/AdminPlatformHealthPage'

export function App() {
  return (
    <Routes>
      {/* Public auth routes — no Layout, no auth requirement */}
      <Route path="auth/signin"  element={<SignInPage />} />
      <Route path="auth/signup"  element={<SignUpPage />} />
      <Route path="auth/forgot"  element={<ForgotPasswordPage />} />
      <Route path="auth/reset"   element={<ResetPasswordPage />} />

      {/* Authenticated app — Layout + RequireAuth gate */}
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="sites" element={<SitesPage />} />
          <Route path="sites/:siteId" element={<SiteDetailPage />} />
          <Route path="sites/:siteId/runs/:runId" element={<RunDetailPage />} />
          <Route path="fixes/:fixId" element={<FixDetailPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="onboard" element={<OnboardPage />} />
          <Route path="settings" element={<SettingsLayout />}>
            <Route index element={<ProfilePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="security" element={<SecurityPage />} />
            <Route path="danger" element={<DangerPage />} />
          </Route>
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<AdminOverviewPage />} />
            <Route path="tenants" element={<AdminTenantsPage />} />
            <Route path="tenants/:id" element={<AdminTenantDetailPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="users/:id" element={<AdminUserDetailPage />} />
            <Route path="sites" element={<AdminSitesPage />} />
            <Route path="runs" element={<AdminRunsPage />} />
            <Route path="fixes" element={<AdminFixesPage />} />
            <Route path="ai-spend" element={<AdminAISpendPage />} />
            <Route path="engines" element={<AdminEnginesPage />} />
            <Route path="rules" element={<AdminRulesPage />} />
            <Route path="audit-log" element={<AdminAuditLogPage />} />
            <Route path="platform-health" element={<AdminPlatformHealthPage />} />
          </Route>
        </Route>
      </Route>

      {/* 404 — last */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
